var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('box',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"px-3 py-1"},[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }